import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة ثلثين عدد ما - احسب ثلثين العدد";
const DESCRIPTION =
  "احسب ثلثي أي عدد بسهولة باستخدام حاسبة ثلثي العدد المجانية والدقيقة.";
const KEYWORDS = "حاسبة, ثلثي العدد, احسب ثلثي عدد ما, حساب ثلثي";
const OG_URL = "https://do-calculate.com/calculator/ar/twothirds-calculator/";
function TwoThirdsCalculator() {
  const [number, setNumber] = useState();
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const [steps, setSteps] = useState("");
  const handleCalculate = () => {
    try {
      if (number) {
        const twoThirds = parseFloat((number / 3) * 2).toFixed(2);
        setResult(twoThirds);
        setSteps(`لحساب ثلثي العدد ${number}:
        \n1. نقسم العدد على 3: ${number} ÷ 3 = ${(number / 3).toFixed(2)}
        \n2. نضرب الناتج في 2: ${(number / 3).toFixed(2)} × 2 = ${twoThirds}`);
        setError("");
      } else {
        setError("الرجاء إدخال رقم من أجل القيام بالعملية الحسابية!");
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  {" "}
                  تقوم هذه الحاسبة بحساب ثلثي أي عدد. لإجراء الحساب، نقوم بتطبيق
                  المعادلة التالية: ثلثي العدد = (العدد × 2) / 3.
                </p>
                <p>لحساب ثلثي عدد ما، اتبع الخطوات التالية:</p>
                <ul>
                  <li>أدخل الرقم الذي تريد حساب ثلثيه في الحقل المخصص.</li>
                  <li>اضغط على زر "احسب".</li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة لتكون سهلة الاستخدام ومفيدة للأشخاص الذين
                  يحتاجون إلى حساب ثلثي عدد ما بشكل سريع ودقيق.
                </p>{" "}
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="number">
                          ادخل الرقم
                        </label>
                      </b>
                      <input
                        id="number"
                        type="number"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        placeholder="أدخل الرقم"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className=" text-white">النتيجة:</h4>
                      <p className="text-white">{result}</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>خطوات الحل:</h4>
                        <p
                          className="text-black"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {steps}
                        </p>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      ما هي حاسبة ثلثي العدد؟{" "}
                    </h2>{" "}
                  </u>
                  <p>
                    حاسبة ثلثي العدد هي أداة مفيدة لحساب ثلثي أي عدد بسهولة.
                    تستخدم هذه الحاسبة معادلة بسيطة لحساب النتيجة.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية استخدام حاسبة ثلثي العدد
                    </h2>{" "}
                  </u>
                  <p>لاستخدام حاسبة ثلثي العدد، اتبع الخطوات التالية:</p>
                  <ol>
                    <li>أدخل الرقم الذي تريد حساب ثلثيه في الحقل المخصص.</li>
                    <li>اضغط على زر "احسب".</li>
                  </ol>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      أمثلة على استخدام حاسبة ثلثي العدد
                    </h2>{" "}
                  </u>
                  <p>
                    {" "}
                    يمكن استخدام حاسبة ثلثي العدد في العديد من المواقف، مثل:
                  </p>
                  <ul>
                    <li>حساب ثلثي كمية المكونات في وصفة.</li>
                    <li>توزيع ثلثي المبلغ على عدة أشخاص.</li>
                    <li>حل مسائل رياضية تتضمن حساب ثلثي عدد ما.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default TwoThirdsCalculator;
